import { useMemo } from 'react';
import { SortOrder, TimeSignal } from 'graphql/types';

export const useSortedNotes = (
  notes: TimeSignal[],
  sortOrder: SortOrder
): TimeSignal[] => {
  return useMemo(() => {
    return notes.sort((ts1: TimeSignal, ts2: TimeSignal) => {
      if (ts1.startTime < ts2.startTime) {
        return sortOrder === SortOrder.Ascending ? -1 : 1;
      }
      if (ts1.startTime > ts2.startTime) {
        return sortOrder === SortOrder.Ascending ? 1 : -1;
      }
      return 0;
    });
  }, [notes, sortOrder]);
};
